export const getGtmBaseUrl = () => {
  const hostname = window.location.hostname;
  return hostname.includes('synthetics.maersk.io') ? process.env.REACT_APP_GTM_BASE_URL : '';
};
